import { RenterPaymentMethodTypeInterface } from './Types';

const PaymentMethodTypesModel = (paymentMethodTypes: RenterPaymentMethodTypeInterface[]) =>
  paymentMethodTypes.map((paymentMethodType) => {
    const { name = '', type = '', rentFee = '', otherFee = '' } = paymentMethodType;

    return {
      name,
      type,
      rentFee,
      otherFee,
    };
  });

export default PaymentMethodTypesModel;
